import { create } from 'zustand';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from '../types/type';

interface TabState {
  // 활성화 탭 상태
  mainTab: MAIN_TAB_STATUS;
  subTabs: {
    [MAIN_TAB_STATUS.REWARD]?: undefined;
    [MAIN_TAB_STATUS.PARTICIPATE]?:
      | SUB_TAB_STATUS.PARTICIPATE_ONLINE
      | SUB_TAB_STATUS.PARTICIPATE_OFFLINE;
    [MAIN_TAB_STATUS.PROGRESS]?: SUB_TAB_STATUS.PROGRESS_MAIN | SUB_TAB_STATUS.PROGRESS_SIDE;
    [MAIN_TAB_STATUS.MAIN_EVENT]?: SUB_TAB_STATUS.MAIN_EVENT_MAIN | SUB_TAB_STATUS.MAIN_EVENT_SIDE;
  };

  // 탭 변경 함수
  setMainTab: (tab: MAIN_TAB_STATUS) => void;
  setSubTab: (mainTab: MAIN_TAB_STATUS, subTab: SUB_TAB_STATUS) => void;

  // 현재 메인탭의 서브탭 상태 확인 함수
  getCurrentSubTab: (mainTab: MAIN_TAB_STATUS) => SUB_TAB_STATUS | undefined;
}

export const tabStore = create<TabState>((set, get) => ({
  // 초기 상태
  mainTab: MAIN_TAB_STATUS.REWARD,
  subTabs: {},

  setMainTab: (tab: MAIN_TAB_STATUS) => {
    set({ mainTab: tab });
  },

  // 서브 탭 변경
  setSubTab: (mainTab: MAIN_TAB_STATUS, subTab: SUB_TAB_STATUS) => {
    set((state) => ({
      subTabs: {
        ...state.subTabs,
        [mainTab]: subTab,
      },
    }));
  },

  // 현재 메인 탭의 서브탭 상태 확인
  getCurrentSubTab: (mainTab: MAIN_TAB_STATUS) => {
    const { subTabs } = get();
    return subTabs[mainTab];
  },
}));
